import { render, staticRenderFns } from "./ReportsCommissions.vue?vue&type=template&id=39a3c846&"
import script from "./ReportsCommissions.vue?vue&type=script&lang=js&"
export * from "./ReportsCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports